import { Component } from '@angular/core';

@Component({
  selector: 'stream-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.less']
})
export class PrivacyPolicyComponent {}
